import { CommonResourcesPackage } from "by/gamefactory/cityversetycoon/scenes/common/resources/CommonResourcesPackage";
import { MyWalletResourcePackage } from "../../resources/MyWalletResourcePackage";
import { NFTScrollItem } from "./scrollItems/NFTScrollItem";
import { NFTDiceRollsScrollItem } from "./scrollItems/NFTDiceRollsScrollItem";
import { NFTPackage, PackageType, TraitType } from "by/gamefactory/web3/nfts/NFTPackage";
import { NFTBuilding } from "by/gamefactory/web3/nfts/NFTBuilding";
import { NFT } from "by/gamefactory/web3/nfts/NFT";
import { NFTBuildingScrollItem } from "./scrollItems/NFTBuildingScrollItem";
import { Texture } from "pixi.js";
import { ILogger } from "by/gamefactory/cityversetycoon/logger/ILogger";
import { DynamicAssets } from "../../../../../../resources/DynamicAssets";
import { IPlayerModel } from "by/gamefactory/cityversetycoon/scenes/common/models/IPlayerModel";
import { NFTPiggyClub } from "by/gamefactory/web3/nfts/NFTPiggyClub";
import { NFTPiggyClubScrollItem, PiggyClubScrollItemOptions } from "./scrollItems/NFTPiggyClubScrollItem";

export class NFTItemsFactory {
    private readonly commonResources: CommonResourcesPackage;
    private readonly myWalletResources: MyWalletResourcePackage;
    private readonly buildingResources: DynamicAssets;
    private readonly piggyClubResources: DynamicAssets;
    private readonly logger: ILogger;
    private readonly playerModel: IPlayerModel;

    public constructor(
        commonResources: CommonResourcesPackage,
        myWalletResources: MyWalletResourcePackage,
        buildingResources: DynamicAssets,
        piggyClubResources: DynamicAssets,
        logger: ILogger,
        playerModel: IPlayerModel
    ) {
        this.commonResources = commonResources;
        this.myWalletResources = myWalletResources;
        this.buildingResources = buildingResources;
        this.piggyClubResources = piggyClubResources;
        this.logger = logger;
        this.playerModel = playerModel;
    }

    public createItem(nftItem: NFT): NFTScrollItem | Array<NFTScrollItem> {
        if (nftItem instanceof NFTPackage) {
            if (nftItem.rewards.some(reward => reward.type === TraitType.DICE_ROLLS)) {
                if (nftItem.quantityOwned === BigInt(1)) {
                    return new NFTDiceRollsScrollItem(this.myWalletResources, this.commonResources, nftItem);
                }
                const result: Array<NFTScrollItem> = [];
                for (let i = 0; i < nftItem.quantityOwned; i++) {
                    result.push(new NFTDiceRollsScrollItem(this.myWalletResources, this.commonResources, nftItem));
                }
                return result;
            }
            else if (nftItem.packageType === PackageType.GOLDEN_WHEEL) {
                this.logger.debug(`Unable to crete view for golden wheel, ignored: ${nftItem.toString()}`);
                return null;
            }
            else {
                this.logger.warn(`Unexpected package without dice rolls: ${nftItem.toString()}`);
                return null;
            }
        }
        if (nftItem instanceof NFTBuilding) {
            const buildingModel = this.playerModel.buildings.value.find((buildingModel) => buildingModel.id.value === nftItem.buildingId);
            const texture = this.buildingResources.resource<Texture>(nftItem.imageURL);
            const piggyTexture = buildingModel.piggyClubImageUrl.value != null && buildingModel.piggyClubImageUrl.value != "" ?
                this.buildingResources.resource<Texture>(buildingModel.piggyClubImageUrl.value) : null;
            const buildingPiggyMultiplier = buildingModel?.piggyMultiplier.value ?? 1;
            const buildingAddress = buildingModel.address.value;
            return new NFTBuildingScrollItem(
                this.commonResources,
                this.myWalletResources,
                texture,
                piggyTexture,
                buildingModel.piggyClubNftMultiplier.value,
                nftItem,
                buildingPiggyMultiplier,
                buildingAddress,
                buildingModel.purchaseHistory.value
            );
        }
        if (nftItem instanceof NFTPiggyClub) {
            const texture = this.piggyClubResources.resource<Texture>(nftItem.imageURL);
            const options: PiggyClubScrollItemOptions = {
                piggyMuiltiplier: nftItem.multiplier,
                supportedBuildingsCount: nftItem.buildingAppliedTo
            }
            return new NFTPiggyClubScrollItem(this.commonResources, this.myWalletResources, texture, nftItem, options);
        }
        this.logger.error(`Unable to create NFT item from nft data: ${nftItem.toString()}`);
        return null;
    }
}
